import { useCallback, useState } from 'react'
import { Calendar, Radio, Clock, Zap } from 'lucide-react'
import AdminScreenShell, { Tegel, StatusRij } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

const fmtTijd = (iso) => iso ? new Date(iso).toLocaleTimeString('nl-BE', { hour:'2-digit', minute:'2-digit' }) : '—'
const fmtDuur = (a, b) => {
  const min = Math.round((new Date(b).getTime() - new Date(a).getTime()) / 60000)
  return min >= 60 ? `${Math.floor(min/60)}u${String(min%60).padStart(2,'0')}` : `${min}m`
}

export default function AdminProgrammaScreen() {
  const [data, setData] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermProgramma(); setData(r.data)
  }, [])
  const bezig = data?.bezig ?? []
  const komt  = data?.eerstvolgende ?? []
  const tracks = data?.tracks ?? []

  return (
    <AdminScreenShell title="Programma" subtitle="Live-tijdlijn · admin-only slots inbegrepen"
                      icon={Calendar} refreshMs={20_000} onRefresh={load}>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <Tegel label="Bezig nu"     waarde={bezig.length} kleur="#B4FF39" groot />
        <Tegel label="Aankomend"    waarde={komt.length}  kleur="#61E294" sub="in de tijdlijn" />
        <Tegel label="Tracks actief" waarde={tracks.length} kleur="#FFB57A" />
        <Tegel label="Editie"       waarde={data?.edition?.name ?? '—'} kleur="#B4FF39" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Radio className="h-3 w-3 inline mr-1 text-signal" /> Bezig nu
          </h2>
          {bezig.length === 0 ? (
            <div className="text-muted-foreground text-sm">Niets in de tijdlijn nu.</div>
          ) : bezig.map(s => (
            <div key={s.id} className="mb-3 pb-3 border-b border-border/40 last:border-0">
              <div className="flex items-start gap-2">
                {s.is_highlight && <Zap className="h-4 w-4 text-gold mt-1 shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="text-lg font-bold">{s.title}</div>
                  <div className="text-xs text-muted-foreground">
                    {s.track ?? '—'} · {fmtTijd(s.starts_at)}–{fmtTijd(s.ends_at)}
                    {s.admin_only && <span className="ml-2 text-signal">· admin only</span>}
                  </div>
                  {s.description && <div className="text-sm mt-1 text-muted-foreground">{s.description}</div>}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="rounded-[6px] border border-border bg-card p-4">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <Clock className="h-3 w-3 inline mr-1" /> Eerstvolgend
          </h2>
          {komt.length === 0 ? (
            <div className="text-muted-foreground text-sm">Geen geplande slots meer.</div>
          ) : komt.map(s => (
            <StatusRij key={s.id}
              naam={`${fmtTijd(s.starts_at)} · ${s.title}`}
              sub={`${s.track ?? '—'} · ${fmtDuur(s.starts_at, s.ends_at)}${s.admin_only ? ' · admin' : ''}`}
              status="gepland" kleur="#B4FF39" />
          ))}
        </div>
      </div>
    </AdminScreenShell>
  )
}
